import React from 'react';
import { Text } from '@/components/ui/primitives';
import { TextProps } from '@/lib/styling';
import { StyleProp, TextStyle } from 'react-native';

interface LabelProps extends TextProps {
  htmlFor?: string; // This is a web-only prop, kept for compatibility
  children?: React.ReactNode;
  className?: string;
  style?: StyleProp<TextStyle>;
}

export function Label({ children, style, className, ...props }: LabelProps) {
  return (
    <Text
      variant="caption"
      color="pressMuted"
      marginBottom="xs"
      style={style}
      {...props}
    >
      {children}
    </Text>
  );
}
